import * as THREE from 'three';
import { Enemy } from './Enemy';
import { AITactic } from '../systems/AIController';

// 重型坦克 - 慢速但高血量高伤害
export class HeavyTank extends Enemy {
  constructor(x: number, z: number) {
    super(x, z, AITactic.AGGRESSIVE); // 使用激进战术

    // 修改外观为更大更重的坦克
    this.mesh.scale.set(1.3, 1.2, 1.3);

    // 修改属性
    this.health = 150;
    this.maxHealth = 150;
    (this as any).moveSpeed = 6; // 更慢
    (this as any).patrolSpeed = 0.2;
    (this as any).chaseSpeed = 0.4;
    (this as any).shootRange = 30; // 射程更远
    (this as any).shootCooldown = 0.8; // 射击更慢

    // 修改颜色为深红色
    const bodyMaterial = new THREE.MeshStandardMaterial({ color: 0x8b0000 });
    (this.mesh.children[0] as THREE.Mesh).material = bodyMaterial;

    // 更新物理体质量
    this.body.mass = 800;
    this.body.updateMassProperties();

    this.body.userData = { type: 'heavy_enemy', tank: this };
  }

  getDamage(): number {
    return 30; // 伤害更高
  }

  getScore(): number {
    return 200; // 分数更高
  }
}

// 轻型坦克 - 快速但低血量
export class LightTank extends Enemy {
  constructor(x: number, z: number) {
    super(x, z, AITactic.EVASIVE); // 使用闪避战术

    // 修改外观为更小的坦克
    this.mesh.scale.set(0.8, 0.9, 0.8);

    // 修改属性
    this.health = 50;
    this.maxHealth = 50;
    (this as any).moveSpeed = 15; // 更快
    (this as any).turnSpeed = 3;
    (this as any).patrolSpeed = 0.6;
    (this as any).chaseSpeed = 1.2;
    (this as any).detectionRange = 35; // 检测范围更大
    (this as any).shootRange = 20;
    (this as any).shootCooldown = 0.3; // 射击更快

    // 修改颜色为橙红色
    const bodyMaterial = new THREE.MeshStandardMaterial({ color: 0xff4500 });
    (this.mesh.children[0] as THREE.Mesh).material = bodyMaterial;

    // 更新物理体质量
    this.body.mass = 300;
    this.body.updateMassProperties();

    this.body.userData = { type: 'light_enemy', tank: this };
  }

  getDamage(): number {
    return 15; // 伤害较低
  }

  getScore(): number {
    return 150; // 分数中等
  }
}

// 狙击坦克 - 远距离攻击
export class SniperTank extends Enemy {
  constructor(x: number, z: number) {
    super(x, z, AITactic.SNIPER); // 使用狙击战术

    // 修改外观
    this.mesh.scale.set(1, 1, 1.2); // 更长的炮管

    // 修改属性
    this.health = 80;
    this.maxHealth = 80;
    (this as any).moveSpeed = 8;
    (this as any).patrolSpeed = 0.25;
    (this as any).chaseSpeed = 0.3;
    (this as any).detectionRange = 40; // 检测范围很大
    (this as any).shootRange = 35; // 射程很远
    (this as any).shootCooldown = 1.5; // 射击慢但准确

    // 修改颜色为深紫色
    const bodyMaterial = new THREE.MeshStandardMaterial({ color: 0x4b0082 });
    (this.mesh.children[0] as THREE.Mesh).material = bodyMaterial;

    this.body.userData = { type: 'sniper_enemy', tank: this };
  }

  getDamage(): number {
    return 40; // 高伤害
  }

  getScore(): number {
    return 250; // 高分数
  }
}

export type EnemyType = 'normal' | 'heavy' | 'light' | 'sniper';

export function createEnemy(type: EnemyType, x: number, z: number): Enemy {
  switch (type) {
    case 'heavy':
      return new HeavyTank(x, z);
    case 'light':
      return new LightTank(x, z);
    case 'sniper':
      return new SniperTank(x, z);
    case 'normal':
    default:
      return new Enemy(x, z);
  }
}
